import Http from "./base-http";

class JobCode extends Http {
  deleteJobCode(id) {
    return this.destroy(id);
  }
  createJobCode(data) {
    return this.client.post('/',data)
  }
  updateJobCodes(id,data) {
    return this.client.put(`/${id}`,data)
  }
}

const jobCodeObj = new JobCode({
  modelUrlPrefix : "jobCode"
});

export default jobCodeObj;
